/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sreality_Seller_RetryInputs */

const cs_sreality_seller_retry = /** @type {(inputs: Sreality_Seller_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Znovu založit makléře`)
};

const en_sreality_seller_retry = /** @type {(inputs: Sreality_Seller_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retry seller provision`)
};

/**
* | output |
* | --- |
* | "Retry seller provision" |
*
* @param {Sreality_Seller_RetryInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const sreality_seller_retry = /** @type {((inputs?: Sreality_Seller_RetryInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sreality_Seller_RetryInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sreality_seller_retry(inputs)
	return cs_sreality_seller_retry(inputs)
});